import { Col, Row } from "reactstrap";
import * as React from "react";
import { useEffect, useState } from "react";
import { useAPIErrorContext } from "../../contexts/apiErrorContext";
import { clientConfig } from "../../utilities/configService";
import { Link } from "react-router-dom";

interface IProps {
    errorCode: string | undefined
}

interface IMailProps {
    children: React.ReactNode,
    email?: string
}

export const Mailto = (props: IMailProps) => {
    return <a href={`mailto:${props.email}`}>{props.children}</a>;
};

export const ErrorBanner = ({ errorCode }: IProps) => {
    const { apiError, clearError } = useAPIErrorContext();
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        if (apiError && !isActive) {
            setIsActive(true);
            window.scrollTo(0, 0);
            setTimeout(() => {
                setIsActive(false);
                clearError();
            }, 10000)
        }
    }, [apiError]);

    const errorMessage = () => {
        if (errorCode && errorCode === 'form') {
            return (
                <div>
                    Our site encountered an error when trying to submit your form. Please try submitting your content again. If this error persists, please contact our program team for assistance at <Mailto email={clientConfig?.HELP_EMAIL_ADDRESS}>{clientConfig?.HELP_EMAIL_ADDRESS}</Mailto>.
                </div>
            );
        }
        else if (errorCode && errorCode === '403') {
            return (
                <div>
                    You must be a registered user of this site to access this resource. <Link to="/Login" target="_self">Click here to create an account.</Link>
                </div>
            );
        }
        else if (errorCode && errorCode === '404') {
            return (
                <div>
                    Requested page cannot be found or no longer exists. Please <Link to="/ContactUs" target="_self">contact our program team</Link> for assistance.
                </div>
            );
        }
        else if (errorCode && errorCode === '401') {
            return (
                <div>
                    You have not yet created an account for this utility\'s PowerGuide Fleets application. You can either register an account or <Link to="/ContactUs" target="_self">contact our program team for assistance</Link>.
                </div>
            );
        }
        else {
            return (
                <div>
                    Our site encountered an error, please try again. If this error persists, please contact our program team for assistance at <Mailto email={clientConfig?.HELP_EMAIL_ADDRESS}>{clientConfig?.HELP_EMAIL_ADDRESS}</Mailto>.
                </div>
            );
        }
    };


    return (
        <div className={`warningBannerContainer ${isActive ? 'active' : 'inactive'}`}>
            {apiError ? (
                <Row className="contentPageHeading warningBanner">
                    <Col className="titleBlock container">
                        <Row>
                            <Col sm={1} className="warningIcon">
                                <svg fill="none" height="60" viewBox="0 0 24 24" width="60" xmlns="http://www.w3.org/2000/svg"><g fill="#000000"><path d="m12 13.75c-.41 0-.75-.34-.75-.75v-5.25c0-.41.34-.75.75-.75s.75.34.75.75v5.25c0 .41-.34.75-.75.75z" /><path d="m12 17.25c-.27 0-.52-.1-.71-.29-.09-.1-.16-.21-.22-.33-.05-.12-.07-.25-.07-.38 0-.26.11-.52.29-.71.37-.37 1.05-.37 1.42 0 .18.19.29.45.29.71 0 .13-.03.26-.08.38s-.12.23-.21.33c-.19.19-.44.29-.71.29z" /><path d="m12.0002 22.7501c-.67 0-1.35-.17-1.95-.52l-5.94003-3.43c-1.2-.7-1.95001-1.99-1.95001-3.38v-6.83999c0-1.39.75001-2.68 1.95001-3.38l5.94003-3.42999c1.2-.7 2.69-.7 3.9 0l5.94 3.42999c1.2.7 1.95 1.99 1.95 3.38v6.83999c0 1.39-.75 2.68-1.95 3.38l-5.94 3.43c-.6.35-1.28.52-1.95.52zm0-20c-.41 0-.83.11-1.2.32l-5.94003 3.43c-.74.43-1.20001 1.22001-1.20001 2.08001v6.83999c0 .85.46001 1.65 1.20001 2.08l5.94003 3.43c.74.43 1.66.43 2.39 0l5.94-3.43c.74-.43 1.2-1.22 1.2-2.08v-6.83999c0-.85-.46-1.65001-1.2-2.08001l-5.94-3.43c-.36-.21-.78-.32-1.19-.32z" /></g></svg>
                            </Col>
                            <Col sm={11} className="warningText">
                                {errorMessage()}
                            </Col>
                        </Row>

                    </Col>
                </Row >
            ) : ('')}
        </div>
    );
}
